import GoogleAnalyticsService from '../../common/services/analytics/google-analytics.service';
import TerritoryService from '../../common/services/territory.service';
import { Country } from '../../common/models/country.model';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { CountryChangeAction } from '../../common/actions/country.action';
import { LanguageChangeAction } from '../../common/actions/language.action';
import { OpenLoginDialogAction } from '../login-dialog/login-dialog.action';
import UserService from '../../common/services/user/user.service';
import { UserResponse } from '../../common/services/user/user.model';
import TokenRedirectService from '../../common/services/token-redirect.service';
import MobileService from '../../common/services/mobile.service';
import AuthService from '../../common/services/auth/auth.service';
import { IWindowService } from 'angular';

/* @ngInject */
export default class HeaderController {
  public countries: Country[] = [];
  public availableLanguages = [];
  public country: Country;
  public language: string;
  public user: UserResponse;
  public isShowMobileMenu = false;
  private redirectUrl: string;

  constructor(
    public config,
    private i18n,
    private $cookies,

    public userService: UserService,
    public mobileService: MobileService,
    private actionDispatcher: ActionDispatcherService,
    private tokenRedirectService: TokenRedirectService,
    private authService: AuthService,
    private $window: IWindowService,
    private googleAnalytics: GoogleAnalyticsService
  ) {
    this.redirectUrl = this.config.auth.logout.redirect || '/';
  }

  public $onInit() {
    this.countries = this.config.countries;
    this.country = this.countries[0];
    this.availableLanguages = this.i18n.getAvailableLanguages();
    this.language = this.i18n.getCurrentLanguage();
    this.userService.getUserInfo().then(data => {
      this.user = data;
    });
  }

  public onLogin() {
    this.actionDispatcher.dispatch(new OpenLoginDialogAction());
  }

  public onCountryChange() {
    this.userService.setTerritory(this.country.territory.toUpperCase());
    this.actionDispatcher.dispatch(new CountryChangeAction(this.country));
  }

  public onLanguageChange = (lang: string) => {
    this.language = lang;
    this.i18n.useLanguage(this.language);
    this.actionDispatcher.dispatch(new LanguageChangeAction(this.language, true));
    this.googleAnalytics.writeVirtualPages({
      language: this.language
    });
  };

  public onListenMusic() {
    this.tokenRedirectService.openPlayer();
  }

  public toggleMenu() {
    this.isShowMobileMenu = !this.isShowMobileMenu;
  }

  public onLogout() {
    const fizyLang = this.$cookies.get('fizy_lang');
    this.authService
      .logout()
      .finally(
        () => {
          sessionStorage.removeItem("masterpass.token");
          this.$window.location.href = this.config.auth.logout.redirectUrl;
        } )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/header/header.controller.ts